<template>
  <div id="save_item_list">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <h1>商品保存リスト</h1>
          <div class="title">
            <h3>カスタマイズ中の商品保存リスト</h3>
            <div class="product_search_cond">
              <div>現在の検索条件:</div>
              <div>{{searchCond}}</div>
            </div>
            <div class="product_search_act">
              <div>該当商品</div>
              <div>{{saveProductCnt}}件</div>
              <div @click="onSearch" class="detail_btn3ex">絞り込み</div>
              <div @click="onReset" class="detail_btn3ex2">条件リセット</div>
            </div>
          </div>
          <div class="caution_field" v-if="isDisProduct===true">
            <div class="caution_inner">
              <div class="caution_title">
                <img class="caution_icon" :src="getImage('common/icon_caution_y.svg')" alt="">
                <p>重要なお知らせ</p>
              </div>
              <ul class="caution_text">
                <li>商品保存リスト内に商品仕様が変更、または取り扱いが終了した商品が含まれています。</li>
                <li>対象商品を商品保存リストから削除し、別の商品をご検討ください。</li>
              </ul>
            </div>
          </div>
          <!-- ページ -->
          <dd-pager
            v-if="saveProductList && saveProductList.length > 0"
            :pageNo="pageNo"
            :dataCountPerPage="pageSaveCnt"
            :totalDataCount="saveProductList.length"
            @callback="paging"
          />
          <section id="save_product_list">
            <div v-for="(item,index) in viewList" :key="'cat-' + index" class="confirm_area">
              <div class="caution_field" v-if="item.isDisProduct===true">
                <div class="caution_inner">
                  <ul class="caution_text">
                    <li>この商品は商品仕様が変更、または取り扱いが終了した為、編集できません。</li>
                    <li>商品保存リストから削除してください。</li>
                  </ul>
                </div>
              </div>
              <!-- <img :src="itemImage(item)" class="item_image"> -->
              <div class="input_confirm2">
                <ul v-bind:class="{'disabled':item.isDisProduct===true, item_title:true}">
                  <li>
                    <span>保存名</span>
                    <span>{{item.businessName}}</span>
                  </li>
                  <li>
                    <span>登録日時</span>
                    <span>{{item.saveDate}}</span>
                  </li>
                  <li>
                    <span>シリーズ名</span>
                    <span>{{item.seriesName}}</span>
                  </li>
                  <li>
                    <span>商品名</span>
                    <span>{{item.productName}}</span>
                  </li>
                  <li v-show="item.colorStyle">
                    <span>スタイル名</span>
                    <span>{{item.colorStyle.colorStyleName}}</span>
                  </li>
                  <li>
                    <span>商品サイズ</span>
                    <div>W:{{item.dcWidth}}mm H:{{item.dcHeight}}mm D:{{item.dcDepth}}mm</div>
                  </li>
                  <template v-if="item.categoryId==4">
                    <li v-if="isEnableFiller(item)">
                      <span>壁埋め込み</span>
                      <div>
                        <span v-show="item.dcBSize!=undefined">左壁：{{item.dcBSize}}mm</span>
                        <span v-show="item.dcCSize!=undefined">右壁：{{item.dcCSize}}mm</span>
                        <span v-show="item.dcDSize!=undefined">奥壁：{{item.dcDSize}}mm</span>
                      </div>
                      <div></div>
                    </li>
                  </template>
                  <template v-else>
                    <li v-if="isEnableFiller(item)">
                      <span>フィラー</span>
                      <div>
                        <span v-show="item.dcBSize!=undefined">左フィラー：{{item.dcBSize}}mm</span>
                        <span v-show="item.dcCSize!=undefined">右フィラー：{{item.dcCSize}}mm</span>
                        <span v-show="item.dcDSize!=undefined">上部フィラー：{{item.dcDSize}}mm</span>
                      </div>
                    </li>
                  </template>
                  <li v-if="item.dcHeight2 != undefined">
                    <span>取り付け高さ設定</span>
                    <span>{{item.dcHeight2}}mm</span>
                  </li>
                  <li v-if="item.dcColorDoorDetail && Object.keys(item.dcColorDoorDetail).length > 0">
                    <span>扉カラー</span>
                    <span>{{item.dcColorDoorDetail.name}}</span>
                  </li>
                  <li v-if="item.dcColorBoxDetail && Object.keys(item.dcColorBoxDetail).length > 0">
                    <span>キャビネット/棚/脚カラー</span>
                    <span>{{item.dcColorBoxDetail.name}}</span>
                  </li>
                  <li v-if="item.dcColorCounterDetail && Object.keys(item.dcColorCounterDetail).length > 0">
                    <span>カウンターカラー</span>
                    <span>{{item.dcColorCounterDetail.name}}</span>
                  </li>
                  <li>
                    <span>可動棚</span>
                    <span>{{item.dcShelfCount}}</span>
                  </li>
                  <li>
                    <span>フィラー数</span>
                    <span>{{item.dcFillerCount}}</span>
                  </li>
                  <li>
                    <span>ご注文数</span>
                    <span>{{item.dcProductCount}}</span>
                  </li>
                  <li>
                    <span>納品先郵便番号</span>
                    <span>{{item.dcSaveDeliPostcd}}</span>
                  </li>
                  <template v-if="item.deliAddress && Object.keys(item.deliAddress).length > 0">
                    <li>
                      <span>納品先住所</span>
                      <span>{{item.deliAddress}}</span>
                    </li>
                  </template>
                  <li>
                    <span>組立設置</span>
                    <span v-if="item.dcWorkFlag===true">あり</span>
                    <span v-else>なし</span>
                  </li>
                  <template v-if="item.dcWorkFlag==true">
                    <li>
                      <span>組立設置先郵便番号</span>
                      <span>{{item.dcStructPostcd}}</span>
                    </li>
                    <li v-if="item.dcConstructOpServiceFlag!=undefined">
                      <span>受け取り搬入サービス</span>
                      <span v-if="item.dcConstructOpServiceFlag===true">あり</span>
                      <span v-else>なし</span>
                    </li>
                  </template>
                  <template v-if="item.dcSaveResrchFlag">
                    <li>
                      <span>事前現場調査：</span>
                      <span>
                        <span v-if="item.dcSaveResrchFlag===true">あり</span>
                        <span v-else>なし</span>
                      </span>
                    </li>
                  </template>
                  <template v-if="item.dcSaveResrchFlag">
                    <li>
                      <span>事前現場調査先郵便番号：</span>
                      <span>{{item.dcSaveResrchPostcd}}</span>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="action_area">
                <div class="main_btn act_sub_btn" @click="selectProduct(item)">
                  <a>編集</a>
                </div>
                <div class="main_btn sel_sub_btn" @click="deleteProduct(item.productId)">
                  <a>削除</a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
// import {mapState} from 'vuex'
// import draggable from 'vuedraggable'

// Module
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Pager from '../../components/common/Pager'
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import Color from '../components/top/input/color/DcColor'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'SaveItemList',
  components: {
    // draggable,
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-pager': Pager,
    'dd-color': Color,
    'dd-loading-modal': LoadingModal,
    'dd-sitemap': DcSiteMap
  },
  props: {
  },
  data () {
    return {
      pageKey: 'dcSaveItem',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'saveItem', key: 'dcSaveItem', title: '保存リスト'}
      ],
      options: {
        animation: 200,
        delay: 50
      },
      pageSaveCnt: 20,
      pageNo: 1,
      drug: false,
      saveProductList: [],
      saveProductCnt: 0,
      searchCond: '条件なし',
      saveName: undefined,
      dateStart: undefined,
      dateEnd: undefined,
      deliAddress: undefined
    }
  },
  computed: {
    viewList: function () {
      if (!this.saveProductList) return
      let startIdx = (this.pageNo - 1) * this.pageSaveCnt
      let endIdx = ((this.pageNo) * this.pageSaveCnt)
      return this.saveProductList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
    },
    isDisProduct: function () {
      if (!this.saveProductList || Object.keys(this.saveProductList).length <= 0) return false
      return this.saveProductList
        .map(i => i.isDisProduct)
        .includes(true)
    }
  },
  methods: {
    selectProduct: function (product) {
      App.setLocalStorage(DC_STORAGE_KEY.SAVE_PLAN, product)
      this.$router.push({
        name: 'DcCustomize',
        query: {id: product.dcFdId, ctype: product.categoryId}
      })
    },
    paging: function (selPage) {
      this.pageNo = selPage
    },
    deleteProduct: function (productId) {
      // 保存リストから削除
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'center',
        onOk: () => {
          let payload = {
            params: {
              productId: productId
            }
          }
          axios.get(DC_URL.SAVE + '/delete-product', payload
          ).then(response => {
            let modalData = {
              messages: ['削除しました。'],
              textAlign: 'center'
            }
            App.showModal(modalData)
            let payload = {
              saveName: this.saveName,
              dateStart: this.dateStart,
              dateEnd: this.dateEnd,
              deliAddress: this.deliAddress
            }
            this.saveListSearch(payload)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$router.push('/mmstyle/error')
          })
        }
      }
      App.showModal(modalData)
    },
    isEnableFiller: function (item) {
      return (item.dcBSize !== undefined || item.dcCSize !== undefined || item.dcDSize !== undefined)
    },
    itemImage: function (item) {
      if (!item || !item.planEc.ecSnapProductImage) return this.getImage('noimage.svg')
      return this.getImage(this.bigImage(item.planEc.ecSnapProductImage))
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    onSearch: function () {
      let modalData = {
        saveList: this.saveList,
        onOk: (callback) => {
          this.searchCond = this.saveSearchCond(callback)
          App.setLocalStorage(DC_STORAGE_KEY.SAVE_PRODUCT_SEARCH, callback)
          document.body.style.overflow = 'scroll'
          let payload = {
            saveName: callback.saveName,
            dateStart: callback.dateStart,
            dateEnd: callback.dateEnd,
            deliAddress: callback.deliAddress
          }
          this.saveName = callback.saveName
          this.dateStart = callback.dateStart
          this.dateEnd = callback.dateEnd
          this.deliAddress = callback.deliAddress
          this.saveListSearch(payload)
        },
        onCancel: (callback) => {
          document.body.style.overflow = 'scroll'
        },
        callbackParams: {}
      }
      AppEc.showSaveProductSerach(modalData)
      document.body.style.overflow = 'hidden'
    },
    onReset: function () {
      App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PRODUCT_SEARCH)
      let payload = {
        saveName: undefined,
        dateStart: undefined,
        dateEnd: undefined,
        deliAddress: undefined
      }
      this.searchCond = '条件なし'
      this.saveListSearch(payload)
    },
    saveListSearch: function (payload) {
      this.$refs.loadingModalRef.showModal(true)
      axios.post(DC_URL.SAVE + '/save-product-search', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.saveProductList = []
            response.data.data.map(d => {
              let product = {
                productId: d.productId,
                businessName: d.businessName,
                seriesName: d.seriesName,
                productName: d.productName,
                saveDate: d.saveDate,
                dcFdId: d.dcFdId,
                fdId: d.fdId,
                categoryId: d.cdcCategoryType,
                dcWidth: d.width,
                dcHeight: d.height,
                dcHeight2: d.height2,
                dcDepth: d.depth,
                dcDepth2: d.depth2,
                dcBSize: d.bsize,
                dcBType: d.btype,
                dcCSize: d.csize,
                dcCType: d.ctype,
                dcDSize: d.dsize,
                dcDType: d.dtype,
                dcColorDoor: d.colorDoor.no,
                dcColorDoorDetail: d.colorDoor.no ? {
                  id: d.colorDoor.no,
                  name: d.colorDoor.name,
                  type: d.colorDoor.type,
                  no: d.colorDoor.dispNo,
                  img: d.colorDoor.img ? App.getMmstyleResource('color/' + d.colorDoor.img) : '',
                  imgB: d.colorDoor.img ? App.getMmstyleResource('color/' + d.colorDoor.img) : ''
                } : {},
                dcColorBox: d.colorCabine.no,
                dcColorBoxDetail: d.colorCabine.no ? {
                  id: d.colorCabine.no,
                  name: d.colorCabine.name,
                  type: d.colorCabine.type,
                  no: d.colorCabine.dispNo,
                  img: d.colorCabine.img ? App.getMmstyleResource('color/' + d.colorCabine.img) : '',
                  imgB: d.colorCabine.img ? App.getMmstyleResource('color/' + d.colorCabine.img) : ''
                } : {},
                dcColorCounter: d.colorCounter.no,
                dcColorCounterDetail: d.colorCounter.no ? {
                  id: d.colorCounter.no,
                  name: d.colorCounter.name,
                  type: d.colorCounter.type,
                  no: d.colorCounter.dispNo,
                  img: d.colorCounter.img ? App.getMmstyleResource('color/' + d.colorCounter.img) : '',
                  imgB: d.colorCounter.img ? App.getMmstyleResource('color/' + d.colorCounter.img) : ''
                } : {},
                dcShelfCount: d.shelfCount,
                dcFillerCount: d.fillerCount,
                dcProductCount: d.productCount,
                dcWorkFlag: d.structFlag,
                dcSaveResrchFlag: d.resrchFlag,
                dcSaveExistDeliFlag: d.existDeliFlag,
                businessId: d.businessId,
                dcSaveDeliPostcd: d.deliPostcd,
                deliAddress: d.deliAddress,
                dcSaveDeliState: '',
                dcSaveDeliCity: '',
                dcSaveDeliStreet: '',
                dcStructSameAddressFlag: d.structSameAddressFlag,
                dcStructPostcd: d.structPostcd,
                dcStructState: '',
                dcStructCity: '',
                dcStructStreet: '',
                dcConstructOpServiceFlag: d.carryInFlag,
                dcSaveExistResrchFlag: d.existResrchFlag,
                dcSaveSameAddressFlag: d.resrchSameAddressFlag,
                dcSaveResrchPostcd: d.resrchPostcd,
                isDisProduct: d.isDisProduct,
                colorStyle: d.colorStyle
              }
              this.saveProductList.push(product)
            })
            this.pageNo = 1
            this.saveProductCnt = this.saveProductList.length
          }
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          Api.handleError(error)
          this.modalShown = false
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
        })
    },
    saveSearchCond: function (callback) {
      let searchCondList = []
      if (callback.saveName) {
        searchCondList.push('保存名:' + callback.saveName)
      }
      if (callback.dateStart && callback.dateEnd) {
        searchCondList.push('登録日時:' + callback.dateStart + '～' + callback.dateEnd)
      } else if (callback.dateStart) {
        searchCondList.push('登録日時:' + callback.dateStart + '～')
      } else if (callback.dateEnd) {
        searchCondList.push('登録日時:' + '～' + callback.dateEnd)
      }
      if (callback.deliAddress) {
        searchCondList.push('納品先住所:' + callback.deliAddress)
      }
      if (searchCondList.length <= 0) return '条件なし'
      return searchCondList.join('、')
    }
    // onMousemove: function (event) {
    //   // let element = document.getElementById('save_item_list')
    //   // console.log('move ev.y:' + event.clientY + ' screenH:' + element.scrollHeight + ' offsetH:' + element.offsetHeight)
    //   // if (element.scrollHeight - (element.offsetHeight + event.clientY) < element.scrollHeight * 0.05) {
    //   //   console.log('scroll end')
    //   // }
    //   // if (this.drug) {
    //   // const scrollAmount = 100
    //   // const par = 0.2
    //   console.log('move ev.y:' + event.clientY + ' screenH:' + window.innerHeight)
    //   // if (event.clientY - 100 < window.innerHeight * par) {
    //   //   window.scrollTo(window.scrollY - scrollAmount, window.scrollX)
    //   // } else
    //   if ((window.innerHeight - event.clientY) < window.innerHeight * 0.2) {
    //     console.log('scroll end')
    //     // スクロールする
    //     // window.scrollTo(window.scrollY + scrollAmount, window.scrollX)
    //     window.scrollTo(0, 0)
    //     // }
    //   }
    // },
    // onSort: function (event) {
    //   console.log('sort')
    // },
    // /** イベントリスナ有効化 */
    // addEventListener: function () {
    //   document.addEventListener('mousemove', this.onMousemove)
    // },
    // /** イベントリスナ無効化 */
    // removeEventListener: function () {
    //   document.removeEventListener('mousemove', this.onMousemove)
    // }
  }, // END methods
  mounted: function () {
    // this.addEventListener()
    let payload = {}
    this.saveListSearch(payload)
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.item {
  display: inline-block;
  margin: 1rem;
  padding: 1rem;
  border: 1px solid #7f7f7f;
  border-radius: 0.5rem;
  background-color: #ffffff;
}
.item:hover {
  cursor: grab;
}
.item:active {
  cursor: grabbing;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSaveItemList.vue